import { Address, AddressAttributes } from "graphql/types";

export default (address: Address): AddressAttributes => ({
  ...address,
  line1: address.line1 ?? "",
  postalCode: address.postalCode ?? "",
  city: address.city ?? "",
  country: address.country ?? "",
});
